/**
 * Contact Form frontend functionality
 */
(function() {
	'use strict';

	// Wait for DOM ready
	document.addEventListener('DOMContentLoaded', function() {
		const forms = document.querySelectorAll('.xtra-contact-form');
		
		forms.forEach(form => {
			new ContactForm(form);
		});
	});

	class ContactForm {
		constructor(container) {
			this.container = container;
			this.form = container.querySelector('form');
			this.submitButton = this.form.querySelector('button[type="submit"]');
			this.honeypot = this.form.querySelector('[name="website"]');
			
			// Get form fields
			this.fields = {
				recipient: this.form.querySelector('[name="recipient"]'),
				name: this.form.querySelector('[name="name"]'),
				email: this.form.querySelector('[name="email"]'),
				message: this.form.querySelector('[name="message"]')
			};
			
			this.init();
		}
		
		init() {
			this.form.addEventListener('submit', (e) => {
				e.preventDefault();
				this.handleSubmit();
			});
		}
		
		getEndpoint() {
			const config = window.XXRest || {};
			if ( config.contactEndpoint ) {
				return config.contactEndpoint;
			}
			if ( config.root ) {
				const root = config.root.replace(/\/$/, '');
				return `${root}/xtraxtra-blocks/v1/contact-form`;
			}
			return '/wp-json/xtraxtra-blocks/v1/contact-form';
		}
		
		async handleSubmit() {
			// Validate form
			if (!this.validateForm()) {
				return;
			}
			
			// Disable form during submission
			this.setLoading(true);
			
			try {
				const payload = {
					recipient: this.fields.recipient ? this.fields.recipient.value : '',
					name: this.fields.name.value.trim(),
					email: this.fields.email.value.trim(),
					message: this.fields.message.value.trim(),
					website: this.honeypot.value // Spam protection
				};

				const response = await fetch(this.getEndpoint(), {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'X-WP-Nonce': window.XXRest?.nonce || ''
					},
					body: JSON.stringify(payload)
				});
				
				const data = await response.json();
				
				if (!response.ok) {
					throw new Error(data.message || 'Failed to send message');
				}
				
				// Show success toast with persistent mode and custom button
				const event = new CustomEvent('xtraxtra:notify', {
					detail: {
						message: 'Thank you! Your message has been sent successfully.',
						type: 'success',
						persistent: true,
						button: {
							text: 'Got it'
						}
					}
				});
				document.dispatchEvent(event);
				
				// Clear form
				this.form.reset();
				
			} catch (error) {
				// Show error toast using event dispatch
				const event = new CustomEvent('xtraxtra:notify', {
					detail: {
						message: error.message || 'Failed to send message. Please try again.',
						type: 'error'
					}
				});
				document.dispatchEvent(event);
			} finally {
				this.setLoading(false);
			}
		}
		
		validateForm() {
			let isValid = true;
			
			// Clear previous errors
			this.clearErrors();
			
			// Validate recipient
			if (!this.fields.recipient || this.fields.recipient.disabled || !this.fields.recipient.value) {
				if (this.fields.recipient) {
					this.showError(this.fields.recipient, 'Please choose who you want to contact');
				}
				isValid = false;
			}
			
			// Validate name
			if (!this.fields.name.value.trim()) {
				this.showError(this.fields.name, 'Name is required');
				isValid = false;
			}
			
			// Validate email
			const email = this.fields.email.value.trim();
			const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			if (!email) {
				this.showError(this.fields.email, 'Email is required');
				isValid = false;
			} else if (!emailRegex.test(email)) {
				this.showError(this.fields.email, 'Please enter a valid email address');
				isValid = false;
			}
			
			// Validate message
			if (!this.fields.message.value.trim()) {
				this.showError(this.fields.message, 'Message is required');
				isValid = false;
			}
			
			return isValid;
		}
		
		showError(field, message) {
			const fieldWrapper = field.closest('.xtra-field');
			if (fieldWrapper) {
				fieldWrapper.classList.add('has-error');
				
				// Create or update error message
				let errorEl = fieldWrapper.querySelector('.xtra-field__error');
				if (!errorEl) {
					errorEl = document.createElement('span');
					errorEl.className = 'xtra-field__error';
					fieldWrapper.appendChild(errorEl);
				}
				errorEl.textContent = message;
			}
		}
		
		clearErrors() {
			this.container.querySelectorAll('.has-error').forEach(el => {
				el.classList.remove('has-error');
			});
			this.container.querySelectorAll('.xtra-field__error').forEach(el => {
				el.remove();
			});
		}
		
		setLoading(loading) {
			this.submitButton.disabled = loading;
			this.submitButton.classList.toggle('loading', loading);
			
			// Update button text
			if (loading) {
				this.submitButton.dataset.originalText = this.submitButton.textContent;
				this.submitButton.textContent = 'Sending...';
			} else {
				this.submitButton.textContent = this.submitButton.dataset.originalText || 'Send Message';
			}
			
			// Disable all inputs
			Object.values(this.fields).forEach(field => {
				if (field) {
					field.disabled = loading;
				}
			});
		}
	}
})();
